// src/features/client-portal/components/ClientLogin/index.jsx
// ✅ صفحة تسجيل دخول الزبون — رقم الهاتف + كلمة المرور

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { clientLogin as clientLoginApi } from '../../../../api';

import { useAuth } from '../../../auth/context/AuthContext';
import styles from './ClientLogin.module.css';

function ClientLogin() {
  const [phone,    setPhone]    = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const navigate = useNavigate();
  const { clientLogin } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await clientLoginApi(phone, password);
      const { token, client } = res.data;

      clientLogin(client, token);
      navigate('/my-bookings');
    } catch (err) {
      const msg = err.response?.data?.non_field_errors?.[0]
        || err.response?.data?.detail
        || err.response?.data?.error
        || 'رقم الهاتف أو كلمة المرور غير صحيحة.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>

        {/* شريط علوي */}
        <div className={styles.topBar} />

        <div className={styles.header}>
          <div className={styles.avatar}>📱</div>
          <h2 className={styles.title}>بوابة العملاء</h2>
          <p className={styles.subtitle}>أدخل رقم هاتفك وكلمة المرور</p>
        </div>

        {error && (
          <div className={styles.error}>
            ⚠️ {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="phone">
              رقم الهاتف
            </label>
            <input
              id="phone"
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="07xxxxxxxxx"
              className={styles.input}
              required
              autoComplete="tel"
              autoFocus
              dir="ltr"
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label} htmlFor="password">
              كلمة المرور
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={styles.input}
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className={styles.submitBtn}
            disabled={loading}
          >
            {loading ? 'جاري الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>

        {/* رابط للموظفين */}
        <p className={styles.staffLink}>
          موظف أو مدير؟{' '}
          <Link to="/login">تسجيل دخول الموظفين</Link>
        </p>
      </div>
    </div>
  );
}

export default ClientLogin;